import { Button, Card, Image, Modal, Space, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PhotoBarcodeService from "../../../../service/PhotoBarcodeService";
import AddPhotoBarcode from "./AddPhotoBarcode";
// import EditPhotoBarcode from "./EditPhotoBarcode";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { API_IMG_NO_OWNER_URL } from "../../../../configs/AppConfig";

const { confirm } = Modal;

const PhotoBarcode = () => {
  const [openAdd, setOpenAdd] = useState({
    open: false,
    storyId: "",
  });

  const [loading, setLoading] = useState(false);

  const [openEdit, setOpenEdit] = useState({
    open: false,
    storyId: "",
  });
  const [PhotoBarcode, setPhotoBarcode] = useState<any>([]);
  const [newPhotoBarcodeId, setNewPhotoBarcodeId] = useState("");

  const showDrawerAdd = async () => {
    setOpenAdd({
      open: true,
      storyId: "",
    });
  };

  const showDrawerEdit = (record: any) => {
    setOpenEdit({ open: true, storyId: record._id });
  };

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      const result = await PhotoBarcodeService.fetchFilter(1);

      setPhotoBarcode({
        data: result.data.noOwnerBarCodePhotos,
        total: result.data.total,
      });
      setLoading(false);
    };
    fetchOrders();
  }, []);

  const columns = [
    // {
    //   title: "品名",
    //   dataIndex: "key",
    //   key: "key",
    // },
    {
      title: "图片",
      dataIndex: "img",
      key: "img",
      width: "70%",

      render: (text: string, record: any) => (
        <>
          <Image width={200} src={API_IMG_NO_OWNER_URL + text} />
        </>
      ),
    },

    {
      title: "更多",
      key: "action",

      render: (text: string, record: any) => (
        <>
          <Space size="middle">
            <Button
              danger
              type="primary"
              onClick={() => {
                deletePhotoBarcodeConfirm(record._id);
              }}
            >
              删除
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const pageChangeHandle = async (page: number, pageSize: number) => {
    setLoading(true);
    const res = await PhotoBarcodeService.fetchFilter(page);
    setPhotoBarcode({
      data: res.data.noOwnerBarCodePhotos,
      total: res.data.total,
    });
    setLoading(false);
  };

  const deletePhotoBarcode = async (id: string) => {
    await PhotoBarcodeService.delete(id);
    window.location.reload();
  };

  const deletePhotoBarcodeConfirm = (id: string) => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      title: "确认删除？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        deletePhotoBarcode(id);
      },
    });
  };

  return (
    <Card>
      <Button
        onClick={showDrawerAdd}
        style={{
          marginTop: 20,
          marginBottom: 20,
          marginLeft: 20,
          backgroundColor: "green",
        }}
        type="primary"
      >
        添加
      </Button>
      <Table
        loading={loading}
        dataSource={PhotoBarcode.data}
        columns={columns}
        rowKey="_id"
        pagination={{
          pageSize: 12,
          total: PhotoBarcode.total,
          onChange: pageChangeHandle,
        }}
      />
      {openAdd && (
        <AddPhotoBarcode openData={openAdd} setOpenData={setOpenAdd} />
      )}
      {/* {openEdit.open && (
        <EditPhotoBarcode openData={openEdit} setOpenData={setOpenEdit} />
      )} */}
    </Card>
  );
};

export default PhotoBarcode;
